export enum UserTypes {
  ADMIN = 'admin',
  TENANT = 'tenant',
}
